import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import GhoveQazaeyeLogo from "../../images/ghove_qazaeye_logo.png"
import VenifyLogo from "../../images/venify_logo.png"
import {Reoverlay} from "reoverlay";
import ConfirmDeleteWidgetModal from "../modals/ConfirmDeleteWidgetModal";
import Api from "../../tools/service";
import {useContext, useState} from "react";
import TransactionalCreditContext from "../../tools/contexts/transationcalCredit/TransactionalCreditContext";
import LoadingScreen from "../LoadingScreen";
import ErrorModal from "../modals/ErrorModal";
import SuccessModal from "../modals/SuccessModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import useDivarAuth from "../../hooks/useDivarAuth";

const WidgetManagement = ({widget, handleInquiry}) => {
    const [loading, setLoading] = useState(false)
    const transactionalCreditContext = useContext(TransactionalCreditContext)
    const {widgets_body, pid} = widget;
    const {token}=useDivarAuth();
    const handleShowDeleteConfirm = () => {
        Reoverlay.showModal(ConfirmDeleteWidgetModal, {
            title: 'حذف افزونه',
            description: 'در صورت حذف افزونه با پرداخت مجدد می‌توانید مجددا افزونه را به آگهی خود اضافه کنید. آیا مطمئن هستید؟',
            showConfirmButton: true,
            confirmButtonText: 'حذف افزونه',
            onDelete: () => {
                setLoading(true)
                Api.delete(REQUEST_URLS.TRANSACTIONAL_CREDIT.DELETE_WIDGET, {
                    params:{
                        pid,
                        post_token:token,
                    },
                    headers: {
                        "Authorization": `Bearer ${transactionalCreditContext.token}`
                    }
                }).then(response => {
                    const {hasError, message} = response;
                    if (hasError) {
                        setLoading(false);
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {

                            },
                            onCancel: () => {
                                Reoverlay.hideModal();

                            }
                        })
                    } else {
                        Reoverlay.showModal(SuccessModal, {
                            title: 'موفق',
                            message: message || 'افزونه با موفقیت حذف شد',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'green',

                            onConfirm: () => {

                            },
                            onCancel: () => {
                                handleInquiry()
                                Reoverlay.hideModal();

                            }
                        })
                        setLoading(false)
                    }
                }).catch(e => {
                    setLoading(false)
                })
            },
            onBack: () => {

            }
        })
    }
    if (loading) {
        return <LoadingScreen text='در حال حذف افزونه'/>
    }
    return <div className="">
        <div className="flex justify-center mt-5 ">
            <p>افزونه شما به صورت زیر روی آگهی قرار دارد.</p>
        </div>
        <div className="w-11/12 mt-5 md:w-6/12 rounded-lg mx-auto bg-white p-5">
            <div className="w-full flex border-b mb-3 pb-3">
                <img src={VenifyLogo} className="w-16 rounded-lg h-auto" alt=""/>
                <div className="flex flex-col mt-2  px-4">
                    <h1 className="font-bold text-lg ">ونیفای</h1>
                    <p>اپراتور هوشمند احراز هویت</p>
                </div>
            </div>
            <div className="flex justify-start items-start">

                <div><img src={GhoveQazaeyeLogo} className="w-20 rounded-lg h-auto" alt=""/></div>
                <div className="flex flex-col mt-2  px-4">
                    <h1 className="font-bold text-lg ">اعتبار معاملاتی</h1>
                    <p> قوه قضائیه</p>
                </div>

            </div>
            <div className="border-t mt-3 pt-3 ">
                <p className="text-sm">{widgets_body?.transactional_inquiry_result}</p>
            </div>
        </div>
        <BottomButtonWrapper grid={2}>
            <Button onClick={handleShowDeleteConfirm} rounded="rounded-lg" className="text-sm " theme="red"
                    outlined={true}>حذف افزونه</Button>
            <Button onClick={() => {
                if (transactionalCreditContext.pid) {
                    transactionalCreditContext.handleGetProcess(transactionalCreditContext.pid)
                } else {
                    transactionalCreditContext.handleCreateProcess()
                }
            }} rounded="rounded-lg" className="text-sm"
                    theme="green">{transactionalCreditContext.pid ? 'ادامه فرایند ' : 'شروع فرایند جدید'}</Button>
        </BottomButtonWrapper>
    </div>
}
export default WidgetManagement;